export enum RelationshipEnum {
  Spouse = 1,
  Daughter = 2,
  Son = 3,
  Parent = 4,
  Sibling = 5,
  Friend = 6,
  InLaw = 7,
  OtherRelative = 8,
  Partner = 9,
  Other = 99
}

export const RelationshipOptions = [
{ id: 1, label: 'Spouse' },
{ id: 2, label: 'Daughter' },
{ id: 3, label: 'Son' },
{ id: 4, label: 'Parent' },
{ id: 5, label: 'Sibling' },
{ id: 6, label: 'Friend' },
{ id: 7, label: 'In-Law' },
{ id: 8, label: 'Other Relative' },
{ id: 9, label: 'Partner' },
{ id: 99, label: 'Other' }
];
